import React from 'react';
import { 
  Box, 
  Paper, 
  Typography, 
  Button, 
  Grid,
  useTheme,
  useMediaQuery 
} from '@mui/material';

const EventCard = ({ eventCard }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Handle both single card and array of cards
  const cards = Array.isArray(eventCard) ? eventCard : [eventCard];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
      {cards.map((card, cardIndex) => (
        <Box 
          key={card?.id || cardIndex}
          sx={{ 
            border: '1px solid #995A00', 
            borderRadius: 2, 
            p: 2, 
            gap: 2, 
            display: 'flex', 
            flexDirection: 'column', 
            width: '100%'
          }}
        >
          <Typography 
            variant="body1"
            fontWeight='600'
          >
            {card?.data?.text}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            {card?.data?.event_summary?.map((item, index) => (
              <Box
                key={item.display_name}
                sx={{
                  borderRight:
                    index !== card?.data?.event_summary.length - 1
                      ? '1px solid #D9D9D9'
                      : 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%',
                  textAlign: 'center',
                  gap: 0.5,
                }}
              >
                <Box
                  component={'img'}
                  src={item?.src}
                  alt="event"
                  sx={{ width: 32, height: 32 }}
                >
                </Box>
                <Typography
                  variant='labelM'
                  sx={{
                    color: '#666',
                  }}
                >
                  {item.display_name}
                </Typography>
                <Typography
                  variant='body1'
                  sx={{
                    fontWeight: '600',
                  }}
                >
                  {item.value !== undefined && item.value !== null ? item.value : '-'}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default EventCard;